<template>
  <div>
    <Table border :columns="alarmData.title" :data="alarmData.data">
    </Table>
    <Page style="float: right;margin-top: 10px;" :total="alarmData.total" :page-size="alarmData.pageSize" @on-change="getRecord2" />
  </div>
</template>

<script>
export default {
  name: 'gasNonitor',
  data() {
    return {
      alarmData: {
        title:[
          { title: '编号', key: 'number' },
          { title: '名称', key: 'channelName' },
          { title: '监测气体', key: 'checkGas' },
          { title: '传感器具体位置', key: 'location' },
          { title: '实时数据', key: 'value' },
          { title: '单位', key: 'physical' },
          { title: '时间', key: 'gmtModified' },
        ],
        data: [],
        total: null,
        pageSize: 10,
        thisPage: 1,
      },
      timer: null, // 定时器名称
    }
  },
  methods:{
    // 获取报警数据  
    getRecord2: function(page) {
      const that = this;
      const data = {};
      data.curPage = page;
      this.alarmData.thisPage = page
      data.limit = this.alarmData.pageSize;
      this.componentsMoudel.startPost('/channelrecord/page_list', data, false).then(res => {
        this.$set(this.alarmData, "data", res.body.data)
        this.$set(this.alarmData, "total", res.body.cum)
      })
    },
  },
  created() {
    this.getRecord2(1)
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getRecord2(this.alarmData.thisPage)
    },5000)
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  }
}
</script>

<style scoped>
  div {
    color: red;
  }
</style>